import React, {useEffect, useState} from "react";
import ReactWordcloud from "react-wordcloud";

import {useRecoilValueLoadable} from "recoil";
import {asyncGetWordCloud, wordCloudType} from "lib/store/dashboard";

import {Box} from "@atsent/components";

import "./WordCloud.scss";

export type WordCloudProps = {
    cx?: string;
};

export const WordCloud: React.FC<WordCloudProps> = ({cx = ""}) => {
    const {state, contents} = useRecoilValueLoadable(asyncGetWordCloud);
    const [wordCloud, setWordCloud] = useState<wordCloudType[]>([]);

    useEffect(() => {
        if (state === "hasValue") {
            setWordCloud(contents);
        }
    }, [state, contents]);

    return (
        <Box cx={`WordCloud ${cx}`}>
            <div className="header">
                <span className="title">워드 클라우드</span>
            </div>
            {
                wordCloud.length > 0 ? <ReactWordcloud
                    words={wordCloud.map(({word, count}) => ({
                        text: word,
                        value: count,
                    }))}
                    options={{
                        fontSizes: [12, 60],
                        rotations: 0,
                    }}
                    callbacks={{
                        getWordColor: () => {
                            return `rgba(var(--primary-rgb),${
                                (Math.floor(Math.random() * 5) * 2 + 2) * 0.1
                            })`;
                        },
                    }}
                /> : <div className="empty">
                    <span>데이터가 없습니다.</span>
                </div>
            }

        </Box>
    );
};
